<template>
  <div id="contact">
    <h2>{{ $t("message.contact.title") }}</h2>
    <hr>
    <div v-show="result">
      <div v-show="success">
        <p class="has-text-success">{{ $t("message.contact.success") }}</p>
      </div>
      <div v-show="!success">
        <p class="has-text-warning">{{ $t("message.contact.error") }}</p>
      </div>
    </div>
    <div v-show="loading" class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-show="!loading && main">
      <section>
        <p>{{ $t("message.contact.subject") }}</p>
        <b-input v-model.trim="subject"></b-input>
        <br>
        <p>{{ $t("message.contact.email") }}</p>
        <b-input v-model.trim="email" type="email"></b-input>
        <br>
        <p>{{ $t("message.contact.content") }}</p>
        <b-input v-model.trim="message" type="textarea"></b-input>
        <br>
        <button class="button is-primary" v-on:click="exec()">{{ $t('message.contact.send') }}</button>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data: function () {
    return {
      main: true,
      loading: false,
      result: false,
      success: false,
      subject: '',
      email: '',
      message: ''
    }
  },
  methods: {
    exec: function () {
      this.loading = true

      this.$axios.post(this.baseURL + '/contact', {
        email: this.email,
        subject: this.subject,
        message: this.message
      }).then(() => {
        this.loading = false
        this.main = false
        this.result = true
        this.success = true
      }).catch(() => {
        this.loading = false
        this.main = false
        this.result = true
        this.success = false
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue